import script from "./ItemSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemSelector.vue?vue&type=script&setup=true&lang=js"

import "./ItemSelector.vue?vue&type=style&index=0&id=7678f37c&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7678f37c"]])

export default __exports__